import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardBody, Row, Col, Table, Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import { FaEnvelope, FaPhone, FaThermometerHalf, FaImages, FaTimes } from 'react-icons/fa';
import { FaImage } from "react-icons/fa6";
import { IoIosDocument } from "react-icons/io";
import { FaCalendar } from "react-icons/fa";
import { LiaComments } from "react-icons/lia";
import { TiSpanner } from "react-icons/ti";
import { FaChartArea } from "react-icons/fa";
import { BASE_URL } from '../../../constants';
import { Alert } from 'bootstrap';

const ViewInspection = (props) => {
    const { id } = useParams();
    const [inspection, setInspection] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isInspectorSignModalOpen, setIsInspectorSignModalOpen] = useState(false);
    const [isTenantSignModalOpen, setIsTenantSignModalOpen] = useState(false);
    const [errMsg, setErrMsg] = useState(null);
    // console.log(id, 'ahmed');
    useEffect(() => {
        fetchData();
    }, [id]);

    const fetchData = () => {
        const token = localStorage.getItem('token');
        if (token) {
            fetch(`${BASE_URL}/inspection/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status) {
                        const formattedInspection = { ...data.result };
                        formattedInspection.created_at = new Date(data.result.created_at).toLocaleDateString('en-US');
                        setInspection(formattedInspection);
                    } else {
                        console.error("Error: Unable to fetch inspections data.");
                    }
                })
                .catch(error => console.error("Error fetching data:", error));
        } else {
            console.error("Error: Authorization token is missing.");
        }
    };

    const getStatusColor = (status) => {
        // console.log(status, 'zain')
        switch (status) {
            case 'NEW':
                return '#34b4eb';
            case 'SATISFACTORY':
                return '#03a631';
            case 'DAMAGE':
                return '#bd060f';
            case 'ATTENTION':
                return '#e6a800';
            case 'NOT_AVAILABLE':
                return '#e68519';
            default:
                return '#000';
        }
    };

    const formatStatus = (status) => {
        switch (status) {
            case 'NEW':
                return ['N', ' ', '-', ' ', '-', ' ', '-', ' ', '-'];
            case 'SATISFACTORY':
                return ['-', ' ', 'S', ' ', '-', ' ', '-', ' ', '-'];
            case 'DAMAGE':
                return ['-', ' ', '-', ' ', 'D', ' ', '-', ' ', '-'];
            case 'ATTENTION':
                return ['-', ' ', '-', ' ', '-', ' ', '!', ' ', '-'];

            case 'NOT_AVAILABLE':
                return ['-', ' ', '-', ' ', '-', ' ', '-', ' ', 'N/A'];
            default:
                return ['-', ' ', '-', ' ', '-', ' ', '-', ' ', '-'];
        }
    };

    const renderFormattedStatus = (status) => {
        const formattedStatus = formatStatus(status);
        // console.log(status, formattedStatus, 'formattedStatus')
        return (
            <span>
                {formattedStatus.map((char, index) => (
                    <span key={index} style={{ color: getStatusColor(status), fontSize: '18px' }}>
                        {char}
                    </span>
                ))}
            </span>
        );
    };

    const formatInspectionActivity = (activity) => {
        return activity
            .replace(/_/g, '-') 
            .split('-') 
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join('-'); 
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const toggleInspectorSignModal = () => {
        setIsInspectorSignModalOpen(!isInspectorSignModalOpen);
    };

    const toggleTenantSignModal = () => {
        setIsTenantSignModalOpen(!isTenantSignModalOpen);
    };

    const handleThumbnailClick = (image, createdAt, areaName, itemName) => {
        setSelectedImage({ image, createdAt, areaName, itemName });
        toggleModal();
    };

    const handleGenerateReport = async () => {
        const token = localStorage.getItem('token');
    
        if (!token) {
            console.error('Error: Authorization token is missing.');
            return;
        }
    
        try {
            const response = await fetch(`${BASE_URL}/inspection/generate/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
    
            const data = await response.json();
            // console.log(data, 'response');
    
            if (data.status) {
                const url = data.result; 
                const newTab = window.open(url, '_blank'); 
    
                if (newTab) {
                    newTab.document.title = 'Inspection Report';
                } else {
                    console.error('Failed to open new tab');
                }
            } else {
                setErrMsg(data.message);
            }
    
        } catch (error) {
            console.error('Error generating PDF:', error);
            setErrMsg(error.message);
        }
    };
    

    return (
        <div className="content">
            {errMsg !== null && <Alert color="danger">{errMsg}</Alert>}
            <Card>
                <CardBody>
                    <Row>
                        <Col xs="9">
                            <div style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                                <FaEnvelope style={{ marginRight: '8px' }} />
                                <span>{inspection?.created_by_email}</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', marginTop: '8px' }}>
                                <FaPhone style={{ marginRight: '8px' }} />
                                <span>{inspection?.created_by_phone}</span>
                            </div>
                        </Col>

                        <Col xs="3" className="d-flex justify-content-end">
                            <Button color="primary" onClick={handleGenerateReport}>
                                Generate Report
                            </Button>
                        </Col>
                    </Row>
                    <hr />
                    <div style={{ margin: '0', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <IoIosDocument style={{ fontSize: '25px', marginRight: '8px' }} />
                        <h4 style={{ margin: '0', fontWeight: 'bold', fontSize: '20px' }}>{inspection ? formatInspectionActivity(inspection?.activity) : 'Loading...'}</h4>
                        {
                            inspection?.is_completed ?
                                <h4 style={{ color: 'green', margin: '0', marginLeft: '10px', fontWeight: 'bold', fontSize: '20px' }}>Completed</h4>
                                :
                                <h4 style={{ color: 'red', margin: '0', marginLeft: '10px', fontWeight: 'bold', fontSize: '20px' }}>In Progress</h4>

                        }

                    </div>
                    <hr />
                    <div style={{ fontWeight: 'bold', fontSize: '15px' }}>
                        <p>{inspection?.tenant[0]?.tenant_first_name} {inspection?.tenant[0]?.tenant_last_name} [{inspection?.created_at}]: Has started {inspection ? formatInspectionActivity(inspection?.activity) : 'Loading...'} for {inspection?.property?.name} on the Inspectaly mobile app.</p>
                    </div>
                    <div style={{ marginTop: '20px', padding: '0 15px', display: 'flex', flexWrap: 'wrap' }}>
                        <div style={{ flex: '1 1 20%', padding: '0 10px' }}>
                            <span style={{ color: '#34b4eb' }}>N= New (just installed or painted)</span>
                        </div>
                        <div style={{ flex: '1 1 20%', padding: '0 10px' }}>
                            <span style={{ color: '#03a631' }}>S= Satisfactory / Acceptable</span>
                        </div>
                        <div style={{ flex: '1 1 20%', padding: '0 10px' }}>
                            <span style={{ color: '#bd060f' }}>D= Existing Damage</span>
                        </div>
                        <div style={{ flex: '1 1 20%', padding: '0 10px' }}>
                            <span style={{ color: '#e6a800' }}>!= Needs attention</span>
                        </div>
                        <div style={{ flex: '1 1 20%', padding: '0 10px' }}>
                            <span style={{ color: '#e68519' }}>N/A= Not Available</span>
                        </div>
                    </div>

                    <hr />
                    <Table responsive>
                        <thead>
                            <tr>
                                <th>Property</th>
                                <th>Renter(s)</th>
                                <th>Date</th>
                                {/* <th>Agent / Inspector</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{inspection?.property.name}</td>
                                {/* <td>{inspection?.tenant?.first_name} {inspection?.tenant?.last_name}</td> */}
                                <td>
                                    {inspection?.tenant?.map((tenant, index) => (
                                        <div key={index}>
                                            {tenant.tenant_first_name} {tenant.tenant_last_name}
                                        </div>
                                    ))}
                                </td>
                                <td>{inspection?.created_at}</td>
                                {/* {inspection?.inspected_by_name && (
                                    <td>{inspection.inspected_by_name}</td>
                                )} */}
                            </tr>
                        </tbody>
                    </Table>
                    <hr />
                    <div style={{ margin: '0', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <FaThermometerHalf style={{ fontSize: '25px', marginRight: '8px' }} />
                        <h5 style={{ fontWeight: 'bold', fontSize: '20px', margin: '0' }}>{inspection ? formatInspectionActivity(inspection?.activity) + ' Conditions' : 'Loading...'}</h5>
                    </div>
                    <hr />
                    <div>
                        {inspection?.areas
                            ?.sort((a, b) => a.order - b.order)
                            ?.map((area, index) => (
                                <div key={index} style={{ marginBottom: '20px' }}>
                                    <Table responsive>
                                        <thead>
                                            <tr>
                                                <th><FaChartArea style={{ fontSize: '15px' }} /> {area.sub_title ? `${area.title}: ${area.sub_title}` : `${area.title}`}</th>
                                                <th>  <FaImages style={{ fontSize: '20px' }} /> Image</th>
                                                <th>  <FaThermometerHalf style={{ fontSize: '20px' }} /> Condition</th>
                                                {/* <th> <TiSpanner style={{ fontSize: '25px' }} /> Action</th> */}
                                                <th> <LiaComments style={{ fontSize: '20px', marginRight: '2px' }} /> Comments</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {area.items.map(item => (
                                                <tr key={item.item_id}>
                                                    <td>{item.name}</td>
                                                    {item.images?.length > 0 ?
                                                        <td>
                                                            {item.images.map((image, imgIndex) => (
                                                                // <img
                                                                //     key={imgIndex}
                                                                //     src={`http://${image.thumbnail}`}
                                                                //     alt="thumbnail"
                                                                //     style={{ width: '60px', cursor: 'pointer' }}
                                                                //     onClick={() => handleThumbnailClick(image.image, area.title, item.name)}
                                                                // />

                                                                <FaImage style={{ fontSize: '20px' }}
                                                                    onClick={() => handleThumbnailClick(image.image, image.created_at, area.title, item.name)}

                                                                />
                                                            ))}
                                                        </td>
                                                        :
                                                        <td></td>
                                                    }
                                                    <td>{renderFormattedStatus(item.status)}</td>
                                                    {/* <td>{item.action}</td> */}
                                                    <td>{item.comments || '-'}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            ))}
                    </div>
                    <div style={{ marginTop: '30px', }}></div>
                    <h6>Additional Comments</h6>
                    {
                        inspection?.final_comments ?
                            <>
                                <div style={{ marginTop: '30px', }}></div>

                                <h6 style={{ marginTop: '15px' }}>Final Comments </h6>
                                <p>{inspection?.final_comments}</p>
                            </>
                            :
                            <></>
                    }

                    {
                        inspection?.inspector_sign ?
                            <>
                                <div style={{ marginTop: '30px', }}></div>
                                <h6>Agent / Inspector Signature </h6>
                                <img
                                    src={inspection?.inspector_sign}
                                    alt="Inspector Image"
                                    style={{ width: '60px', height: 'auto' }}
                                    onClick={toggleInspectorSignModal}
                                />
                            </>
                            :
                            <></>
                    }
                    {
                        inspection?.tenant_sign ?
                            <>
                                <div style={{ marginTop: '30px' }}></div>
                                <h6>Renter Signature </h6>
                                <img
                                    src={inspection?.tenant_sign}
                                    alt="Renter Image"
                                    style={{ width: '60px', height: 'auto' }}
                                    onClick={toggleTenantSignModal}
                                />
                            </>
                            :
                            <></>
                    }

                    {/* <Row>
                        {inspection?.areas?.map((area, index) => {
                            const hasImages = area.items.some(item => item.images.length > 0);
                            return (
                                <React.Fragment key={index}>
                                    {hasImages && <h5>{area.sub_title ? `${area.title}: ${area.sub_title}` : area.title}</h5>}
                                    <Row>
                                        {area.items.map(item => (
                                            <React.Fragment key={item.item_id}>
                                                {item.images.map((image, imgIndex) => (
                                                    <Col xs="6" key={imgIndex}>
                                                        <div>
                                                            {image.image && (
                                                                <a href={`http://${image.image}`} target="_blank" rel="noopener noreferrer">
                                                                    <img
                                                                        src={`http://${image.image}`}
                                                                        alt="image"
                                                                        style={{ width: '60px', height: 'auto' }}
                                                                    />
                                                                </a>
                                                            )}
                                                            {item.images.length > 0 && <p>{item.name}</p>}
                                                            <p><FaCalendar /> {new Date(image.created_at).toLocaleString()}</p>
                                                        </div>
                                                    </Col>
                                                ))}
                                            </React.Fragment>
                                        ))}
                                    </Row>
                                </React.Fragment>
                            );
                        })}
                    </Row> */}

                    <Modal isOpen={isModalOpen} toggle={toggleModal} centered size="md">
                        <ModalHeader toggle={toggleModal} style={{ display: 'flex', justifyContent: 'space-between' }} close={
                            <button className="close" onClick={toggleModal} style={{ outline: 'none', border: 'none', background: 'transparent' }}>
                                <FaTimes size={20} />
                            </button>
                        }>
                            <div>{selectedImage?.areaName}</div>

                            <div style={{ marginTop: '5px', fontSize: '0.9rem' }}>{selectedImage?.itemName}</div>

                        </ModalHeader>
                        <ModalBody>
                            <img
                                src={selectedImage?.image}
                                alt="Full size"
                                style={{ width: '100%' }}
                            />

                            <div style={{ marginTop: '15px' }}></div>

                            <p><FaCalendar /> {new Date(selectedImage?.createdAt).toLocaleDateString('en-US')}</p>
                        </ModalBody>
                    </Modal>

                    <Modal isOpen={isInspectorSignModalOpen} toggle={toggleInspectorSignModal} centered size="md">
                        <ModalHeader toggle={toggleInspectorSignModal} style={{ display: 'flex', justifyContent: 'space-between' }} close={
                            <button className="close" onClick={toggleModal} style={{ outline: 'none', border: 'none', background: 'transparent' }}>
                                <FaTimes size={20} />
                            </button>
                        }>Inspector Signature</ModalHeader>
                        <ModalBody>
                            <img
                                src={inspection?.inspector_sign}
                                alt="Inspector Signature"
                                style={{ width: '100%' }}
                            />
                        </ModalBody>
                    </Modal>

                    <Modal isOpen={isTenantSignModalOpen} toggle={toggleTenantSignModal} centered size="md">
                        <ModalHeader toggle={toggleTenantSignModal} style={{ display: 'flex', justifyContent: 'space-between' }} close={
                            <button className="close" onClick={toggleModal} style={{ outline: 'none', border: 'none', background: 'transparent' }}>
                                <FaTimes size={20} />
                            </button>
                        }>Renter Signature</ModalHeader>
                        <ModalBody>
                            <img
                                src={inspection?.tenant_sign}
                                alt="Renter Signature"
                                style={{ width: '100%' }}
                            />
                        </ModalBody>
                    </Modal>

                </CardBody>
            </Card>
        </div>
    );
};

export default ViewInspection;
